import { z } from 'zod';
export const nonNegativeNumber = (label) => z.number().min(0, `${label} must be a non-negative number.`);
//# sourceMappingURL=non-negative-number.js.map